import angular from 'angular';

class paymentDetailsCtrl {
    /*  @ngInject */
    constructor($uibModal, $state) {
        this.$uibModal = $uibModal;
        this.$state = $state;
    }

    $onInit() {}

    openModalJson(jsonValue, title) {
        this.$uibModal.open({
            component: 'modalJson',
            size: 'lg',
            resolve: {
                json: () => jsonValue,
                title: () => 'payment.details.' + title + '.json_title',
            },
        });
    }

    goBack() {
        this.$state.go('app.payment.list');
    }
}

angular.module('app.payment').component('paymentDetails', {
    templateUrl: require('./payment-details.html'),
    controller: paymentDetailsCtrl,
    bindings: {
        payment: '<',
    },
});
